<template>
  <a-modal
    v-model="isShow"
    centered
    title="合同提醒"
    :mask-closable="true"
  >
    <template slot="footer">
      <a-button type="primary" @click="closeModal">
        我知道了
      </a-button>
    </template>

    <div class="contract-alert-body">
      <a-icon
        :type="iconType"
        class="contract-alert-icon"
        :class="'contract-alert-icon--' + alertLevel"
      />
      <div class="contract-alert-text">
        <div class="contract-alert-title">{{ alertTitle }}</div>
        <div class="contract-alert-description">{{ alertContent }}</div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'ContractAlertModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    alertInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    alertType() {
      return this.alertInfo.alert_type || this.alertInfo.alertType || ''
    },
    alertLevel() {
      if (this.alertType === 'expired') {
        return 'error'
      }
      return 'warning'
    },
    iconType() {
      if (this.alertType === 'expired') {
        return 'close-circle'
      }
      return 'exclamation-circle'
    },
    alertTitle() {
      switch (this.alertType) {
        case 'missing':
          return '合同未上传'
        case 'expiring_soon':
          return '合同即将到期'
        case 'expired':
          return '合同已到期'
        default:
          return '合同提醒'
      }
    },
    alertContent() {
      const agentName = this.alertInfo.agent_name || this.alertInfo.agentName || '该客户'
      const expiresAt = this.alertInfo.expires_at || this.alertInfo.expiresAt || ''

      switch (this.alertType) {
        case 'missing':
          return `${agentName}尚未上传合同文件，请尽快上传。`
        case 'expiring_soon':
          return `${agentName}的合同将于 ${expiresAt} 到期，请及时续签。`
        case 'expired':
          return `${agentName}的合同已于 ${expiresAt} 到期，请尽快续签。`
        default:
          return `${agentName}的合同需要关注，请尽快处理。`
      }
    }
  },
  methods: {
    closeModal() {
      this.isShow = false
    }
  }
}
</script>

<style scoped>
.contract-alert-body {
  display: flex;
  align-items: flex-start;
}

.contract-alert-icon {
  font-size: 22px;
  margin-right: 12px;
  margin-top: 2px;
}

.contract-alert-icon--warning {
  color: #faad14;
}

.contract-alert-icon--error {
  color: #f5222d;
}

.contract-alert-title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 8px;
}

.contract-alert-description {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.6;
}
</style>
